import ProductPlacementItem from "./ProductPlacementItem";

export default ProductPlacementItem;
